import axios from "../axios";
import { Cookies } from "react-cookie";
import { loginfill, update } from "./personal_cookies";

const cookie = new Cookies();
const endPoint = `/user`;

export const signupapi = async ({
  email,
  first_name,
  last_name,
  password,
  username,
  telephone,
}) => {
  return await axios.post(`${endPoint}/sign_up`, {
    email,
    first_name,
    last_name,
    password,
    username,
    telephone,
  });
};
export const loginapi = async ({ email, password }) => {
  const res = await axios.post(`${endPoint}/login`, { email, password });
  if (res.data.success) {
    cookie.set("user", "Bearer " + res.data.token, { path: "/" });
    update()
    return true;
  } else return false;
};
//socialLogin
export const socialLoginGoogle = async ({ idToken}) => {
  const res = await axios.post(`${endPoint}/google-login`, {idToken});
  if (res.data.success) {
    cookie.set("user", "Bearer " + res.data.token, { path: "/" });
    update()
    return {result:true,response:res.data};
  } else return {result:false,response:res.data};
};
//socialLogin facebook
export const socialLoginFacebook = async ({ response}) => {
  const res = await axios.post(`${endPoint}/facebook-login`, {response});
  if (res.data.success) {
    cookie.set("user", "Bearer " + res.data.token, { path: "/" });
    update()
    return true;
  } else return false;
};

export const getprofileapi = async () => {
  const token = cookie.get("user");
  return await (
    await axios.get(`${endPoint}/view_profile`, {
      headers: { Authorization: token },
    })
  ).data;
};

export const getallusers = async () => {
  //const token = cookie.get("admin"); awaiting pagenation
  return await await axios.get(
    `${endPoint}/` /*, {
      headers: { Authorization: token },
    }*/
  );
};
export const view = async (id) => {
  const token = cookie.get("user");
  if (token) {
    axios.post(
      `${endPoint}/view`,
      { id: id },
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};


export const updateUser = async ({firstName,lastName,phoneNumber}) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.patch(
      `${endPoint}/update_profile`,
      {   first_name: firstName,
        last_name: lastName,
        telephone: phoneNumber,},
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};


export const viewed = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/viewed`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};


export const changePassword = async ({password,cPassword}) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.patch(
      `${endPoint}/update_password`,
      {password,cPassword},
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};


export const softDelete = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.delete(
      `${endPoint}/softDelete`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};


/// add addresses 
export const addAddress = async (formData) => {
  const token = cookie.get("user");
  if (token) {
    return await axios.post(
      `${endPoint}/create-address`,
      {formData},
      {
        headers: { Authorization: token },
      }
    );
  } else return false;
};


//get address


export const getAddress = async () => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.get(
      `${endPoint}/get-addresses`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};

//delete address

//delete address
export const deleteAddress = async (addressId) => {
  const token = cookie.get("user");
  if (token) {
    return await (axios.delete(
      `${endPoint}/delete/${addressId}`,
      {
        headers: { Authorization: token },
      }
    ))
  } else return false;
};

